<template>
  <v-main>
    <router-view />
  </v-main>
</template>

<script>
export default {
  name: "InternalCoreView",

  components: {
    // DashboardCoreFooter: () => import("./Footer"),
  },
};
</script>
